export const TEXT = ['011'];
export const CENTER = ['032', '021', '041'];
export const LEFT = ['031', '022', '042'];
export const FULLWIDTH = ['033', '043'];
